import React from "react";
import { RadioWrapper, RadioLabel, SegmentedContainer, SegmentItem } from "./styles";
import {ExportFormat} from "../../../common/home/store/model";

interface ExportFormatToggleProps {
  value: ExportFormat;
  onChange: (format: ExportFormat) => void;
  label?: string;
}

const ExportFormatToggle = ({ value, onChange, label = "Export Format" }: ExportFormatToggleProps) => {
  return (
    <RadioWrapper>
      <RadioLabel>{label}</RadioLabel>
      <SegmentedContainer>
        <SegmentItem isChecked={value === "CSV"}>
          <input
            type="radio"
            name="exportFormat"
            value="CSV"
            checked={value === "CSV"}
            onChange={() => onChange("CSV")}
          />
          CSV
        </SegmentItem>
        <SegmentItem isChecked={value === "XLSX"}>
          <input
            type="radio"
            name="exportFormat"
            value="XLSX"
            checked={value === "XLSX"}
            onChange={() => onChange("XLSX")}
          />
          XLSX
        </SegmentItem>
      </SegmentedContainer>
    </RadioWrapper>
  );
};

export default ExportFormatToggle;